<template>
	<div class="site-header" :style="headerStyle">
		<div class="container navWrapper">
			<div class="nav">
				<router-link :to="{ name: '/' }">
					<img class="logo" src="../../assets/fhnw-logo.svg" :style="logoStyle">
				</router-link>
			</div>

			<div class="nav">
				<router-link :to="{ name: 'checklists' }" :style="linkStyle">
					Checklisten
				</router-link>
				<router-link :to="{ name: 'exercises' }" :style="linkStyle">Übungen</router-link>
				<router-link :to="{ name: 'quizzes' }" :style="linkStyle">Quizze</router-link>
				<router-link :to="{ name: 'templates' }" :style="linkStyle">Vorlagen</router-link>
			</div>

			<div class="nav" id="header-actions" :style="headerActionsStyle">
				<div class="nav-items">
					<div
						class="info-icon"
						@click="showInfoPopup = true"
						title="Information"
						:style="infoIconStyle"
					>
						<img
							src="../../assets/icons/information.svg"
							alt="Info"
							:style="infoIconImgStyle"
						>
					</div>
				</div>
				<div class="nav-items">
					<router-link
						class="info-icon"
						:to="{ name: 'search' }"
						title="Suche"
						:style="linkStyle"
					>
						<img
							src="../../assets/icons/search.svg"
							alt="Search"
							:style="infoIconImgStyle"
						>
					</router-link>
				</div>
			</div>
		</div>

		<div v-if="showInfoPopup" class="popup-overlay" @click.self="closePopup">
			<div class="popup">
				<div class="popup-content">
					<h3>Erklärvideo</h3>
					<iframe
						width="640"
						height="360"
						src="https://tube.switch.ch/embed/TWjNy92Scc"
						frameborder="0"
						allow="fullscreen"
					></iframe>
					<button @click="showInfoPopup = false">Schließen</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'HeaderNavigation',
	data() {
		return {
			showInfoPopup: false,
		};
	},
	computed: {
		// Placeholder inline styles to satisfy bindings; override here if needed
		headerStyle() {
			return {};
		},
		linkStyle() {
			return {};
		},
		infoIconStyle() {
			return {};
		},
		infoIconImgStyle() {
			return {};
		},
		logoStyle() {
			return {};
		},
		headerActionsStyle() {
			return {};
		},
	},
	methods: {
		closePopup() {
			this.showInfoPopup = false;
		},
		onKeyDown(e) {
			if (e.key === 'Escape' && this.showInfoPopup) {
				this.closePopup();
			}
		},
	},
	mounted() {
		document.addEventListener('keydown', this.onKeyDown);
	},
	beforeDestroy() {
		document.removeEventListener('keydown', this.onKeyDown);
	},
};
</script>

<style scoped>
.site-header {
	background-color: #eef6ff;
	padding-top: 23px;
	padding-bottom: 23px;
	margin-bottom: 30px;
}

.favorite {
	fill: #064e81;
}

.navWrapper {
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	width: 80%;
	margin: 0 auto;
}

.disabled {
	cursor: not-allowed;
	text-decoration: none !important;
}

.site-header a {
	white-space: nowrap;
	padding-right: 1rem;
	padding-left: 1rem;
	color: #064e81;
	text-decoration: none;
}

/* .site-header a:hover {
    font-weight: bold;
  } */

.logo {
	height: 35px;
}

.profile {
	line-height: 24px;
}

.profile img {
	height: 100%;
	width: auto;
}

.nav-items {
	display: flex;
	flex-direction: row;
	align-items: center;
}

.nav a:hover {
	text-decoration: underline;
}

.info-icon {
	cursor: pointer;
	padding: 0.5rem;
	display: flex;
	align-items: center;
	justify-content: center;
	border-radius: 50%;
	transition: background-color 0.2s ease;
}

.info-icon img {
	width: 20px;
	height: 20px;
}

.popup-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background-color: rgba(0, 0, 0, 0.5);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 100002;
	/* Higher than header-actions */
}

.popup {
	background-color: white;
	padding: 2rem;
	border-radius: 8px;
	box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
	width: 90%;
	max-width: 700px;
	max-height: 90vh;
	overflow-y: auto;
}

.popup-content {
	text-align: center;
}

.popup-content iframe {
	max-width: 100%;
	width: 640px;
	height: 360px;
	margin: 1rem 0;
}

.popup-content h3 {
	color: #064e81;
	margin-bottom: 1rem;
}

#header-actions {
	position: relative;
	z-index: 100001;
	background-color: #eef6ff;
	padding: 8px 12px;
	border-radius: 8px;
	margin-right: 0.5rem;
}

.popup-content button {
	margin-top: 1rem;
	padding: 0.5rem 1rem;
	background-color: #064e81;
	color: white;
	border: none;
	border-radius: 4px;
	cursor: pointer;
}

.popup-content button:hover {
	background-color: #053e68;
}
</style>
